import { resolveGitlabBaseUrl } from '@/helpers/resolveGitlabBaseUrl';

const getGithubUrl = (repoName: string, repoOwner: string) => {
  return `https://github.com/${repoOwner}/${repoName}`;
};

const getGitlabUrl = (
  repoName: string,
  repoOwner: string,
  repoAlias: string,
  authUrl?: string
) => {
  const url = `${resolveGitlabBaseUrl(authUrl)}/${repoOwner}/${repoName}`;

  if (repoAlias) {
    return `${url}/${repoAlias}`;
  }

  return url;
};

export const mountRepoURL = (
  repoName?: string,
  provider?: string,
  authUrl?: string
) => {
  if (!repoName || !provider) {
    return null;
  }

  if (provider === 'github') {
    return `https://github.com/${repoName}`;
  }

  return `${resolveGitlabBaseUrl(authUrl)}/${repoName}`;
};
